import { PropertyTypes, PropertyUsages } from ".";

export interface CoborrowerInLead {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}
export interface Lead {
  borrower_id?: string;
  annual_income?: string;
  charity?: string;
  created_at?: string;
  credit_score?: string;
  downpayment?: string;
  email: string;
  first_name?: string;
  id?: number;
  last_name?: string;
  max_price_qualified_for?: string;
  monthly_debt?: string;
  name?: string;
  phone?: string;
  previous_agent?: string;
  purchase_stage?: string;
  property_city?: string;
  property_price?: string;
  property_state?: string;
  property_type?: PropertyTypes;
  property_usage?: PropertyUsages;
  source?: string;
  state?: string;
  time_frame?: string;
  total_funds?: string;
  updated_at?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_keyword?: string;
  hl_order_id?: number;
  coborrowers: CoborrowerInLead[];
}

export enum HLStageTypes {
  AdverseAction = "adverse_action",
  CreditApplicationStarted = "credit_application_started",
  CreditCheckPassed = "credit_check_passed",
  BorrowersAuthSigned = "borrowers_auth_signed",
  ConditionallyApproved = "conditionally_approved",
  ContractReceived = "contract_received",
  Funded = "funded",
  InBorrowerUnderwriting = "in_borrower_uw",
  InClosing = "in_closing",
  //  IncompleteApplication = "incomplete_application", // not being sent to HL
  MortgageApproved = "mortgage_approved",
  PreApprovalCompleted = "pre_approval_completed",
  PreApprovalFailed = "pre_approval_failed",
  PreApprovalStarted = "pre_approval_started",
}

export const HumanizedHLStageTypes: { [key in HLStageTypes]: string } = {
  [HLStageTypes.AdverseAction]: "Adverse action",
  [HLStageTypes.CreditApplicationStarted]: "Credit application started",
  [HLStageTypes.CreditCheckPassed]: "Credit check passed",
  [HLStageTypes.BorrowersAuthSigned]: "Borrowers authorization signed",
  [HLStageTypes.ConditionallyApproved]: "Conditionally approved",
  [HLStageTypes.ContractReceived]: "Contract received",
  [HLStageTypes.Funded]: "Funded",
  [HLStageTypes.InBorrowerUnderwriting]: "In borrower underwriting",
  [HLStageTypes.InClosing]: "In closing",
  [HLStageTypes.MortgageApproved]: "Mortgage approved",
  [HLStageTypes.PreApprovalCompleted]: "Preapproval completed",
  [HLStageTypes.PreApprovalFailed]: "Preapproval failed",
  [HLStageTypes.PreApprovalStarted]: "Preapproval started",
};
